
export interface ITotal {
    amount: number;
    value: number;
    pendingValue?: number;
    pendingPercentage?: number;
    usedValue?: number;
    usedPercentage?: number;
    issuedValue?: number;
    currency: string;
    decimals: number;
    xType?: EXRateType;
}

export enum EXRateType {
    cost = "cost",
    retail = "retail",
}
